export default "__VITE_ASSET__0ff14c2f__"